import React from "react";
import PropTypes from "prop-types";
import UserContact from "../../../../../components/userContact/userContact";

const Scorecards = ({ scorecards }) => (
  <div className={"risk-scorecards  membershipWidget"}>
    <UserContact showEmail={false} showPhone={false} data={scorecards} showMoreButton={false} />
  </div>
);

export default Scorecards;

Scorecards.propTypes = {
  scorecards: PropTypes.array
};
